export default __webpack_public_path__ + "static/tech-debt-010f5284c39819f0b8d72514ad3cd1b4.jpg";